export var NotificationsUnreadOption;
(function (NotificationsUnreadOption) {
    NotificationsUnreadOption["ALL"] = "all";
    NotificationsUnreadOption["UNREAD"] = "unread";
})(NotificationsUnreadOption || (NotificationsUnreadOption = {}));
